import React from 'react';
import {defaultTemplate} from 'core/hoc';

import { NumericInput } from 'core/components';
import {renderIf, isSome} from 'core/utils';
import '@progress/kendo-react-intl'

const NumericInputFieldTemplate = defaultTemplate(({ field, showLabel=true, showSpinners = true, onBlur = null, onFocus = null, type = 'n2',  disabled, t, setDefaultType = false, showChangeFlag = false, toolTipPlace = 'top', previousValue = '', isNiko = false, nikoInputData /*customRef*/ }) => {
    // const required = field.rules && field.rules.indexOf('required') !== -1;
    const requiredMark = field.rules && field.rules.indexOf('required') !== -1 ? <span className="validation__mark">*</span> : null;
    const maxValue = field.rules && field.rules.indexOf('max') !== -1 ? parseInt((/max:(\d+)/).exec(field.rules)[1]) : undefined;
    const minValue = field.rules && field.rules.indexOf('min') !== -1 ? parseInt((/min:(\d+)/).exec(field.rules)[1]) : undefined;

    if(field.type == 'integer')
        type = 'n0';

    let value = field.value === '' ? null : field.value;
    if(setDefaultType){
        type = undefined;
        if (value < 0) {
            value = 0;
        }
    }

    return (
        <React.Fragment>
            {showLabel && <div className='form__group__label'>{t(field.label)}{requiredMark}</div>}
            {renderIf(isSome(field.localizedError))(<div
                className="validation__message"> <i className="u-icon u-icon--xsml u-icon--warning u-mar--right--tny"></i>{field.localizedError}</div>)}
            <NumericInput
                className={"input--numeric " + (field.localizedError ? "input--warning" : null)}
                // required={required}
                // showLabel={showLabel}
                // label={field.label}
                max={maxValue}
                min={minValue}
                format={type}
                disabled={disabled || field.disabled}
                onChange={field.onChange}
                defaultValue={null}
                value={value}
                spinners={showSpinners}
                onBlur={onBlur}
                onFocus={onFocus}
                showChangeFlag={showChangeFlag}
                toolTipPlace={toolTipPlace}
                previousValue={previousValue}
                isNiko={isNiko}
                nikoInputData={nikoInputData}
                //customRef={customRef}
            />
        </React.Fragment>
    )
});

export default NumericInputFieldTemplate;
